












import Vue, { PropOptions } from 'vue';
import { validateCampaign } from '../../rules/campaign.rules';
import { Campaign, CampaignStatus, CampaignAudienceType } from '@/models';
import ModalCampaignActivate from '@/components/campaign/ModalCampaignActivate.vue';
import ButtonAction from '@/components/ButtonAction.vue';
export default Vue.extend({
  components: { ModalCampaignActivate, ButtonAction },
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  data() {
    return {
      modalVisible: false,
    };
  },
  computed: {
    isValid(): boolean {
      return validateCampaign(this.campaign) === true;
    },
  },
  methods: {
    async updateCampaignStatus(newStatus: string) {
      try {
        await this.$store.dispatch('updateCampaign', {
          status: newStatus,
          objectId: this.campaign.objectId,
        });
        this.campaign.status = newStatus as any;
        this.$store.commit('addSnackbar', {
          text: `Campanha ativada com sucesso`,
          color: 'success',
        });
      } catch (error) {
        this.$store.commit('addSnackbar', {
          text: `Erro ao ativar campanha: ${error.message}`,
        });
      }
    },
    async activate() {
      if (this.campaign.status === CampaignStatus.Draft) {
        if (this.isValid) {
          this.modalVisible = true;
        } else {
          this.$store.commit('addSnackbar', {
            text: `Essa campanha possui dados inválidos, edite-a e tente novamente.`,
          });
        }
      } else {
        await this.updateCampaignStatus(CampaignStatus.Schedulled);
      }
    },
    async onCloseActivate(confirmed: boolean) {
      this.modalVisible = false;
      if (confirmed) {
        await this.updateCampaignStatus(CampaignStatus.Schedulled);
      }
    },
  },
});
